import React, { useState } from 'react';
import { render } from 'react-dom';
import { CnInput, CnDialog } from '@alife/cn-ui/dist/cn-ui.js';
import { IS_BRAZIL, IS_US_STATION } from '@/constant';
import './v2.css';
const URLParams = new URLSearchParams(window.location.search);
const sceneId = URLParams.get('sceneId') || '';
const redirectUrl = URLParams.get('redirectURL') || '';
const needOrder = URLParams.get('needOrder') === 'true';
let language = URLParams.get('language') || 'zh';
let orderId = '';
function onSuccess(captchaVerifyParam) {
    if (!redirectUrl)
        return;
    let url = new URL(redirectUrl);
    let extraBailingConfig = {
        captchaVerifyParam,
        sceneId,
    };
    if (url.searchParams.has('extraBailingConfig')) {
        try {
            extraBailingConfig = {
                ...JSON.parse(url.searchParams.get('extraBailingConfig')),
                ...extraBailingConfig,
            };
        }
        catch (e) {
            console.error('解析 extraBailingConfig 错误， 忽略 extraBailingConfig' +
                extraBailingConfig);
        }
    }
    url.searchParams.set('extraBailingConfig', JSON.stringify(extraBailingConfig));
    url.searchParams.set('isCaptchaCheck', 'true');
    if (needOrder) {
        if (orderId && orderId.length) {
            url.searchParams.set('orderType', 'mailno');
            url.searchParams.set('orderId', orderId.trim());
        }
        else {
            url.searchParams.set('noOrder', 1);
        }
    }
    // 允许的协议
    const validProtocol = ['https:', 'http:'];
    const validHostList = [
        'cainiao.com',
        'taobao.com',
        'aliexpress.com',
        'cainiao-inc.com',
        'tmall.com',
        'cainiao.cn',
        'taobao.cn',
        'aliexpress.cn',
        'cainiao-inc.cn',
        'tmall.cn',
    ];
    if (validProtocol.includes(url.protocol) &&
        validHostList.some((v) => {
            // 全匹配
            if (v === url.host)
                return true;
            // 匹配 *.host 类型
            return url.host.endsWith('.' + v);
        })) {
        window.location.href = url.toString();
    }
    else {
        console.error('invalid url link', url.toString());
    }
}
switch (language.toLowerCase()) {
    case 'zh':
    case 'zh-cn':
    case 'zh-zh':
        language = 'cn';
        break;
    case 'zt':
        language = 'tw';
        break;
    case 'en-us':
    case 'en':
        language = 'en';
        break;
    case 'ru':
    case 'ru-ru':
        language = 'ru';
        break;
    // 法语暂时用英语代替
    case 'fr':
    case 'fr-fr':
        language = 'fr';
        break;
    case 'es':
    case 'es-es':
        language = 'es';
        break;
    case 'pt':
    case 'pt-pt':
        language = 'pt';
        break;
    case 'he':
    case 'iw-IL':
        language = 'he';
        break;
    default:
        language = 'cn';
}
const isRtl = language === 'he';
let langPackMap = {
    ru: {
        'machine-auth-modal-cancel-button': 'Перевод на оператора',
        'machine-auth-modal-order-tital': 'Для оперативной консультации подготовьте и введите трек-номер вашей посылки.',
        'machine-auth-modal-ok-button': 'Нет трек-номера посылки',
        'machine-auth-modal-input-hint': 'Пожалуйста, укажите трек-номер посылки\nТрек-номер, RLxxxxxxxxxxxx',
        'machine-auth-modal-order-type-invalid': 'Текущий номер документа вводится неверно. Проверьте информацию о номере документа и введите его снова',
    },
    tw: {
        'machine-auth-modal-cancel-button': '進入諮詢',
        'machine-auth-modal-order-tital': '請輸入你要諮詢的單號,以便更快為您解答',
        'machine-auth-modal-ok-button': '沒有單號,直接諮詢',
        'machine-auth-modal-input-hint': '請輸入運單號,如JN1234567',
        'machine-auth-modal-order-type-invalid': '當前輸入單號不正確，請核對單號資訊後再次輸入。',
    },
    pl: {
        'machine-auth-modal-cancel-button': 'Wprowadź konsultację',
        'machine-auth-modal-order-tital': 'Wprowadź numer nieparzysty, z którym chcesz się skonsultować, aby móc szybciej odpowiedzieć.',
        'machine-auth-modal-ok-button': 'Brak liczby nieparzystej, bezpośrednie konsultacje',
        'machine-auth-modal-input-hint': 'Wprowadź numer listu przewozowego, na przykład JN1234567',
        'machine-auth-modal-order-type-invalid': 'O número de entrada atual está incorreto. Verifique as informações do número e tente novamente.',
    },
    en: {
        'machine-auth-modal-cancel-button': 'Enter',
        'machine-auth-modal-order-tital': 'Please enter your tracking number to get an answer faster.',
        'machine-auth-modal-ok-button': 'Consult without tracking number',
        'machine-auth-modal-input-hint': IS_US_STATION
            ? 'Please enter the tracking number, for example, CNUSUPxxxxxx'
            : 'Please enter the waybill number, such as JN1234567',
        'machine-auth-modal-order-type-invalid': 'The current order number is incorrect. Please verify the order number information and enter it again.',
    },
    tr: {
        'machine-auth-modal-cancel-button': 'Konsültasyona girin',
        'machine-auth-modal-order-tital': 'Lütfen daha hızlı cevap verebilmeniz için danışmak istediğiniz tek numarayı girin.',
        'machine-auth-modal-ok-button': 'Tek numara yok, doğrudan danışmanlık',
        'machine-auth-modal-input-hint': 'Lütfen jn1234567 gibi irsaliye numarasını girin',
        'machine-auth-modal-order-type-invalid': 'Mevcut sipariş numarası yanlış. Lütfen sipariş numarası bilgilerini doğrulayın ve tekrar girin.',
    },
    cn: {
        'machine-auth-modal-cancel-button': '进入咨询',
        'machine-auth-modal-order-tital': '请输入你要咨询的单号，以便更快为您解答',
        'machine-auth-modal-ok-button': '没有单号,直接咨询',
        'machine-auth-modal-input-hint': '请输入要咨询的单号（运单，交易单，LP，LBX都支持）',
        'machine-auth-modal-order-type-invalid': '当前输入单号不正确，请核对单号信息后再次输入',
    },
    es: {
        'machine-auth-modal-cancel-button': 'Entrar',
        'machine-auth-modal-order-tital': 'Por favor inserte el número de seguimiento',
        'machine-auth-modal-ok-button': 'Consultar sin número de seguimiento',
        'machine-auth-modal-input-hint': 'El número de seguimiento normalmente tiene 18 dígitos',
        'machine-auth-modal-order-type-invalid': 'El número de pedido actualmente ingresado es incorrecto. Por favor, verifique la información del número de pedido y vuelva a ingresarlo.',
    },
    fr: {
        'machine-auth-modal-cancel-button': 'Entrer',
        'machine-auth-modal-order-tital': 'Veuillez saisir le numéro de suivi afin que nous puissions vous aider rapidement.',
        'machine-auth-modal-ok-button': "Si vous n'avez pas le numéro de suivi, vous pouvez nous contacter pour vous aider.",
        'machine-auth-modal-input-hint': 'Merci de rajouter le no. de suivi, par exemple DOFR, CNFR ou par LP',
        'machine-auth-modal-order-type-invalid': 'Le numéro de commande actuellement saisi est incorrect. Veuillez vérifier les informations relatives au numéro de commande et saisir à nouveau.',
    },
    pt: {
        'machine-auth-modal-cancel-button': 'Iniciar um pedido de suporte',
        'machine-auth-modal-order-tital': 'Por favor, insira o número de seguimento da encomenda que deseja consultar para que possamos esclarecer a sua dúvida de forma mais rápida',
        'machine-auth-modal-ok-button': 'Iniciar um pedido de suporte sem número de seguimento',
        'machine-auth-modal-input-hint': IS_BRAZIL
            ? 'Por favor, insira o número de seguimento, por exemplo, CNBRxxxxxx'
            : 'Por favor, insira o número de seguimento, por exemplo, CNPRTxxxxxxx',
        'machine-auth-modal-order-type-invalid': 'O número de entrada atual está incorreto. Verifique as informações do número e tente novamente.',
    },
    he: {
        'machine-auth-modal-cancel-button': 'המשך לשאול',
        'machine-auth-modal-order-tital': 'אנא הזן את מספר ההזמנה שברצונך לברר לגביה, לעזרה מהירה',
        'machine-auth-modal-ok-button': 'אין מספר הזמנה, המשך ישירות לשאול',
        'machine-auth-modal-input-hint': 'נא להזין מספר מעקב, לדוגמא PH8000123456',
        'machine-auth-modal-order-type-invalid': 'מספר ההזמנה הנוכחי אינו נכון. נא לבדוק את פרטי מספר ההזמנה ולנסות שוב.',
    },
};
function needOrderOnSuccess(captchaVerifyParam) {
    const langPack = langPackMap[language] || langPackMap.cn;
    function App() {
        const [oId, setOrderId] = useState(orderId);
        const [hintMessage, setHintMessage] = useState('');
        const props = {
            visible: true,
            closeMode: false,
            title: langPack['machine-auth-modal-order-tital'],
            bodyStyle: {
                minHeight: 0,
            },
            style: {
                direction: isRtl ? 'rtl' : 'unset',
            },
            children: (<div>
          <CnInput state={hintMessage ? 'error' : undefined} trim style={{ width: '100%' }} placeholder={langPack['machine-auth-modal-input-hint']} onChange={(v) => {
                    setOrderId(v);
                    orderId = v;
                    setHintMessage('');
                }} defaultValue={orderId}/>
          <div style={{ color: 'red' }}>{hintMessage}</div>
        </div>),
            onOk: () => {
                if (!orderId)
                    return Promise.reject('');
                // see more: https://project.aone.alibaba-inc.com/v2/project/1129818/req/74333722
                let reg = /^([a-zA-Z]|\d)+$/gi;
                if (!reg.test(orderId.trim())) {
                    // '当前输入单号不正确，请核对单号信息后再次输入'
                    setHintMessage(langPack['machine-auth-modal-order-type-invalid']);
                    return Promise.reject('');
                }
                onSuccess(captchaVerifyParam);
            },
            onCancel: () => {
                orderId = '';
                onSuccess(captchaVerifyParam);
            },
            okProps: {
                children: langPack['machine-auth-modal-cancel-button'],
                disabled: !oId,
            },
            cancelProps: {
                children: langPack['machine-auth-modal-ok-button'],
            },
        };
        return <CnDialog {...props}/>;
    }
    try {
        window.captcha && window.captcha.hide();
    }
    catch (e) { }
    render(<App />, document.createElement('div'));
}
export default function () {
    let captcha;
    let showBtn = document.createElement('button');
    showBtn.id = 'captchaButton';
    showBtn.style = 'display:none';
    document.body.appendChild(showBtn);
    // 弹出式，除region和prefix以外的参数
    window.initAliyunCaptcha({
        language: language,
        upLang: {
            cn: {
                SLIDE_TIP: '滑动验证您不是机器人',
                SUCCESS: '验证通过',
                // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
                // 验证失败的提示文案，滑块验证和一点即过形态下适用。
                SLIDE_FAIL: '验证未通过',
                // 网络情况异常的提示文案。
                CONGESTION: '非常抱歉，这出错了...',
                // 验证超时的提示文案。嵌入式没有关闭按钮。
                OVERTIME_TIP: '经检测你当前操作环境存在风险，请输入验证码',
                OVERTIME_TIP_BOX: '验证码错误，请重新输入',
            },
            en: {
                // 字段同上
                SLIDE_TIP: 'Slide to verify you are not a robot',
            },
            ru: {
                SLIDE_TIP: 'Проведите, чтобы подтвердить, что вы не робот',
                // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
                VERIFYING: 'Загрузка...',
                SUCCESS: 'Проверено',
                // 验证失败的提示文案，滑块验证和一点即过形态下适用。
                SLIDE_FAIL: 'Проверка не удалась',
                // 网络情况异常的提示文案。
                CONGESTION: 'К сожалению что-то пошло не так…',
                // 验证超时的提示文案。嵌入式没有关闭按钮。
                OVERTIME_TIP: 'Было обнаружено, что ваша операционная система не защищена. Введите код проверки',
                OVERTIME_TIP_BOX: 'Неверный проверочный код, введите еще раз',
            },
            es: {
                // 不同验证形态下的交互提示文案。
                SLIDE_TIP: 'Desliza para verificar que no eres un robot',
                // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
                VERIFYING: 'Cargando...',
                // 验证通过的提示文案，所有验证形态通用。
                SUCCESS: 'Verificación correcta ',
                // 验证失败的提示文案，滑块验证和一点即过形态下适用。
                SLIDE_FAIL: 'Verificación fallida',
                // 网络情况异常的提示文案。
                CONGESTION: 'Desafortunadamente algo salió mal...',
                // 验证超时的提示文案。嵌入式没有关闭按钮。
                OVERTIME_TIP: 'Se ha detectado que su entorno operativo está desprotegido. Introduzca el código de verificación',
                OVERTIME_TIP_BOX: 'Código de verificación inválido, vuelva a introducirlo',
            },
            fr: {
                // 不同验证形态下的交互提示文案。
                SLIDE_TIP: "Glissez pour vérifier que vous n'êtes pas un robot",
                // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
                VERIFYING: 'Chargement en cours',
                // 验证通过的提示文案，所有验证形态通用。
                SUCCESS: 'Vérification réussie',
                // 验证失败的提示文案，滑块验证和一点即过形态下适用。
                SLIDE_FAIL: 'Échec de la vérification',
                // 网络情况异常的提示文案。
                CONGESTION: "Malheureusement, quelque chose s'est mal passé",
                // 验证超时的提示文案。嵌入式没有关闭按钮。
                OVERTIME_TIP: "L'environnement de votre serveur a été détecté comme n'étant pas protégé. Veuillez saisir le code de vérification.",
                OVERTIME_TIP_BOX: 'Code de vérification erroné, veuillez le saisir à nouveau',
            },
            pt: {
                // 不同验证形态下的交互提示文案。
                SLIDE_TIP: 'deslize para confirmar que não é um robô',
                // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
                VERIFYING: 'Carregando',
                // 验证通过的提示文案，所有验证形态通用。
                SUCCESS: 'Verificação concluída',
                // 验证失败的提示文案，滑块验证和一点即过形态下适用。
                SLIDE_FAIL: 'A verificação não foi aprovada',
                // 网络情况异常的提示文案。
                CONGESTION: 'Lamentamos muito, houve um erro',
                // 验证超时的提示文案。嵌入式没有关闭按钮。
                OVERTIME_TIP: 'Após detecção, foi identificado um risco no seu ambiente de operação atual. Por favor, insira o código de verificação',
                OVERTIME_TIP_BOX: 'Código de verificação incorreto, por favor tente novamente',
            },
            he: {
                // 不同验证形态下的交互提示文案。
                SLIDE_TIP: 'החלק כדי לאמת שאינך רובוט ',
                // 验证请求的过程提示文案，滑块验证和一点即过形态下适用。
                VERIFYING: 'טעינת...',
                // 验证通过的提示文案，所有验证形态通用。
                SUCCESS: 'אימות עבר',
                // 验证失败的提示文案，滑块验证和一点即过形态下适用。
                SLIDE_FAIL: 'אימות נכשל',
                // 网络情况异常的提示文案。
                CONGESTION: 'אני מצטער מאוד, זה לא בסדר...',
                // 验证超时的提示文案。嵌入式没有关闭按钮。
                OVERTIME_TIP: 'לאחר גילוי כי סביבת ההפעלה הנוכחית שלך בסכנה, אנא הזן את קוד האימות.',
                OVERTIME_TIP_BOX: 'שגיאת קוד אימות, אנא הזינו מחדש',
            },
        },
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        SceneId: sceneId,
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: 'popup',
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: '#nc_token',
        // 触发验证码弹窗或无痕验证的元素
        button: '#captchaButton',
        // 验证码验证通过回调函数
        success: needOrder ? needOrderOnSuccess : onSuccess,
        // 验证码验证不通过回调函数
        fail: function (result) {
            // 入参为不通过信息
            // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
            console.error(result);
        },
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: function (instance) {
            captcha = instance;
            window.captcha = instance;
            if (captcha) {
                captcha && captcha.show();
            }
        },
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
            width: 320,
            height: 60,
        },
        // ...其他参数，参考initAliyunCaptcha参数说明
    });
}
